import {Component, OnInit} from "@angular/core";
import {BaseComponent} from "../../../base.component";
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";
import {GqlShopSessionService} from "../../../../checkout/graphql/shop-session/gql-shop-session.service";
import {ShopSessionUtil} from "../shop-session-util";
import {forkJoin} from "rxjs";
import {AppConfigService} from "../../../config/app-config.service";

@Component({
    selector: 'ssd-tab-share',
    templateUrl: './ssd-tab-share.component.html',
    styleUrls: ['../shop-session-dashboard-tab.scss'],
    standalone: false
})
export class SsdTabShareComponent extends BaseComponent implements OnInit {

    countryTotals: any = [];
    loading: boolean = false;

    // secondsBack: string = "604800";
    secondsBack: string = "3600";

    shopperSource: string = "all";
    shopperSources: string[] = [];

    shareType: string = "all";
    shareTypes: string[] = [];

    shareFrom: string = "all";
    shareFroms: string[] = [];
    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private gqlShopSessionService: GqlShopSessionService,
        private appConfigService: AppConfigService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.getDashboardSharePrep();
        this.getLocaleTotals();
    }

    getLocaleTotals() {
        this.loading = true;
        const dashboardTotalsFilter = {
            secondsBack: parseInt(this.secondsBack),
            shopperSource: this.shopperSource,
            shareType: this.shareType,
            shareFrom: this.shareFrom
        };
        forkJoin([
            this.appConfigService.getAppConfig(),
            this.gqlShopSessionService.getShopSessionDashboardShare(dashboardTotalsFilter)
        ]).subscribe(([appConfig, shopSessionDashboard]) => {
            this.countryTotals = ShopSessionUtil.createCountryTotals(shopSessionDashboard.localeTotals, appConfig.allowedCountries);
            this.loading = false;
        });
    }

    getDashboardSharePrep() {
        const secondsBackForFilter = 60 * 60 * 24 * 14; // get unique types and shopperSources for the last 14 days
        this.gqlShopSessionService.getDashboardSharePrep(secondsBackForFilter).subscribe((dashboardSharePrep: any) => {
            this.log.debug("dashboardSharePrep", dashboardSharePrep);
            this.shopperSources = dashboardSharePrep.shopperSources || [];
            this.shareTypes = dashboardSharePrep.shareTypes || [];
            this.shareFroms = dashboardSharePrep.shareFroms || [];
        });
    }
}
